import ReactGA from "react-ga4";

export const initGA = () => {
  ReactGA.initialize("G-XZ3CK4Q2C3"); // Substitua pelo seu ID
};

export const logPageView = (path) => {
  ReactGA.send({ hitType: "pageview", page: path });
};
